import gql from 'graphql-tag'

export const SUBMIT_AUTOCITE_METADATA = gql`
  mutation SubmitAutociteMetadata($request: AutociteInput!) {
    submitAutociteMetadata(request: $request)
  }
`
